import { Injectable } from '@angular/core';
import {GetAndSetCartDataInLocalstorageService} from "../cart/service/set-cart-data-in-localstorage.service";
import {CartTransmissionService} from "../raintree/transmission/cart/cart-transmission.service";
import {Cart} from "../cart/interface/cart";
import {RequestMapperService} from "../request-mapper.service";
import {RaintreeResponse} from "../raintree/interface/raintree-response";
import {Product} from "../product-details/interface/product";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {isEmptyObject, isEmptyString} from "bmx-pastebox";
import {MatDialog} from "@angular/material/dialog";
import {GetCart, SelectedFabric} from "../cart/interface/cart-get";
import {CartDialogComponent} from "../cartv2/cart-dialog/cart-dialog.component";
import {CartInformationService} from "../cartv2/cart-information.service";
import {CartItem} from "../cartv2/interface/cart-item";
import {BloomsightService} from "../bloomsight.service";

@UntilDestroy()
@Injectable({
	providedIn: 'root'
})
export class ProductCartService {

	public cartItemList: CartItem[] = [];

	constructor(
		private _cartPopup: GetAndSetCartDataInLocalstorageService,
		private _cartTransmission: CartTransmissionService,
		private _dialog: MatDialog,
		private _cartService: CartInformationService,
		private _bloomsight: BloomsightService
	) {
		this._cartService.items$.subscribe(items => {
			this.cartItemList = items;
		});
	}

	private _addCartData(data: Cart, isSwatch: boolean = false) {
		if (data.fabricProductId === 0) delete data.fabricProductId;
		if (data.selectedSizeProfileOptionId === 0) delete data.selectedSizeProfileOptionId;
		if (data.finishedProductId === 0) delete data.finishedProductId;
		if (data.selectedFabricId === 0) delete data.selectedFabricId;

		this._cartTransmission.AddCartItem(
			RequestMapperService.ADD_CART_ITEM,
			data,
			() => {
			},
			() => {
			},
			(response: RaintreeResponse) => {
				this._dialog.closeAll();
				this._cartService.fetchCartFromAPI(true);
				if(!isSwatch) {
					if(data.orderType === 'PRE_ORDER') {
						this._bloomsight.trackDataEvent(
							'65f035fefe3931befe4c47b9',
							{sku: data.sku},
							'Pre order - Add to cart'
						);
					}
					else {
						this._bloomsight.trackDataEvent(
							'65f033d3fe3931befe4c45f5',
							{sku: data.sku},
							'Add to cart'
						);
					}

				}
				else {
					this._bloomsight.trackDataEvent(
						'65f0365bfe3931befe4c47ef',
						{sku: data.sku},
						'Swatch - Add to cart'
					);
				}
			},
			(error: string) => {
			},
			() => {
			}
		)
	}

	private _updateCartData(data: Cart) {
		if (data.fabricProductId == 0) delete data.fabricProductId;
		if (data.selectedSizeProfileOptionId == 0) delete data.selectedSizeProfileOptionId;
		if (data.finishedProductId == 0) delete data.finishedProductId;

		this._cartTransmission.updateCartItem(
			RequestMapperService.UPDATE_CART_ITEM,
			data,
			() => {
			},
			() => {
			},
			(response: RaintreeResponse) => {
				this._dialog.closeAll();
				this._cartService.fetchCartFromAPI(true);
			},
			(error: string) => {
			},
			() => {
			}
		)
	}

	private _compareCustomSizeObject(obj1: any, obj2: any): boolean {
		if(obj1 && obj2) {
			if (Object.keys(obj1).length !== Object.keys(obj2).length)
				return false;
			for (let key in obj1) {
				if (obj1[key] !== obj2[key])
					return false;
			}
		}
		return true;
	}

	public addSwatchToCart(fabricProductId: number, product: Product, swatchPrice: number) {
		let data: Cart = {
			fabricProductId: fabricProductId,
			finishedProductId: 0,
			quantity: 1,
			unit: 'UNIT',
			price: swatchPrice,
			selectedFabricId: product.madeToOrderProfileEnabled &&product.madeToOrderFabric? product.madeToOrderFabric.id : 0,
			selectedSizeOptionId: 0,
			selectedFinishId: "",
			orderType: 'IN_STOCK',
			productGroup: 'swatch',
			makingCharge: product.price,
			customSize: {},
			sku: product.sku
		}
		let swatchAlreadyInCart: CartItem | undefined = this.cartItemList.find((item: CartItem) => {
			return item.productGroup === 'swatch' && item.fabricProductPreview?.id === fabricProductId;
		});
		if (swatchAlreadyInCart) {
			data.quantity = swatchAlreadyInCart.quantity + 1;
			data.id = swatchAlreadyInCart.id;
			this._updateCartData(data);
		}
		else {
			this._addCartData(data, true);
		}
	}

	public addFabricProduct(
		fabricProductId: number,
		product: Product,
		quantity: number,
		makingCharge: number,
		customSize: any,
		selectedFabricId: number,
		selectedSizeOptionId: number,
		orderType: string,
		selectedFinishId: string,
		calculatedPrice: number,
	) {
		let data: Cart = {
			fabricProductId: fabricProductId,
			quantity: quantity,
			unit: product.unit,
			price: calculatedPrice,
			selectedFabricId: selectedFabricId,
			selectedSizeOptionId: selectedSizeOptionId,
			selectedFinishId: selectedFinishId,
			orderType: orderType,
			productGroup: 'fabric',
			makingCharge: makingCharge,
			customSize: customSize,
			sku: product.sku
		}
		if(customSize && Object.keys(customSize).length > 0){
			selectedSizeOptionId = 0;
			data.selectedSizeOptionId = selectedSizeOptionId;
		}
		if (selectedFinishId)
			data.finishDisplayName = product.finishProfileEnabled && product.finishProfile ? product.finishProfile.displayName : '';
		if (selectedSizeOptionId)
			data.sizeDisplayName = product.sizeProfileEnabled && product.sizeProfile ? product.sizeProfile.displayName : '';

		let existingFabricProduct: CartItem | undefined = this.cartItemList.find((item: CartItem) => {
			let isProductGroupMatched = item.productGroup === 'fabric';
			let isProductIdMatched = item.fabricProductPreview?.id === fabricProductId;
			let isFabricIdMatched: boolean = false;
			if((!item.selectedFabric && !selectedFabricId)) {
				isFabricIdMatched = true;
			}
			else if (item.selectedFabric && !item.selectedFabric.product && !selectedFabricId) {
				isFabricIdMatched = true;
			}
			else {
				isFabricIdMatched = item.selectedFabric && item.selectedFabric.product ? item.selectedFabric.product.id === selectedFabricId: false;
			}
			let isSizeOptionIdMatched = false;
			if(!item.selectedSizeOption && !selectedSizeOptionId) {
				isSizeOptionIdMatched = true;
			}
			else {
				isSizeOptionIdMatched = item.selectedSizeOption?.id === selectedSizeOptionId;
			}
			let isFinishIdMatched = item.selectedFinishList?.map((item) => item.id).join(',') === selectedFinishId;
			let isOrderTypeMatched = item.orderType === orderType;
			let isCustomSizeMatched = this._compareCustomSizeObject(item.customSize, customSize);
			// console.log(isFinishIdMatched, isOrderTypeMatched, isFabricIdMatched, isProductIdMatched, isProductGroupMatched, isSizeOptionIdMatched, isCustomSizeMatched);
			return isProductGroupMatched && isProductIdMatched && isFabricIdMatched && isSizeOptionIdMatched && isFinishIdMatched && isOrderTypeMatched && isCustomSizeMatched;
		});

		if (existingFabricProduct) {
			data.quantity = existingFabricProduct.quantity + quantity;
			data.id = existingFabricProduct.id;
			this._updateCartData(data);
		}
		 else {
			this._addCartData(data);
		}
	}


	public addFinishedProduct(
		finishedProductId: number,
		product: Product,
		quantity: number,
		makingCharge: number,
		customSize: any,
		selectedFabricId: number,
		selectedSizeOptionId: number,
		orderType: string,
		selectedFinishId: string,
		calculatedPrice: number,
	) {
		let data: Cart = {
			finishedProductId: finishedProductId,
			quantity: quantity,
			unit: product.unit,
			price: calculatedPrice,
			selectedFabricId: selectedFabricId,
			selectedSizeOptionId: selectedSizeOptionId,
			selectedFinishId: selectedFinishId,
			orderType: orderType,
			productGroup: 'finished',
			makingCharge: makingCharge,
			customSize: customSize,
			sku: product.sku
		}
		if(customSize && Object.keys(customSize).length > 0){
			selectedSizeOptionId = 0;
			data.selectedSizeOptionId = selectedSizeOptionId;
		}
		if (selectedFinishId)
			data.finishDisplayName = product.finishProfileEnabled && product.finishProfile ? product.finishProfile.displayName : '';
		if (selectedSizeOptionId)
			data.sizeDisplayName = product.sizeProfileEnabled && product.sizeProfile ? product.sizeProfile.displayName : '';

		let existingFinishedProduct: CartItem | undefined = this.cartItemList.find((item: CartItem) => {

			let isProductGroupMatched = item.productGroup === 'finished';
			let isProductIdMatched = item.finishedProductPreview?.id === finishedProductId;
			let isFabricIdMatched: boolean = false;
			if((!item.selectedFabric && !selectedFabricId)) {
				isFabricIdMatched = true;
			}
			else if (item.selectedFabric && !item.selectedFabric.product && !selectedFabricId) {
				isFabricIdMatched = true;
			}
			else {
				isFabricIdMatched = item.selectedFabric && item.selectedFabric.product ? item.selectedFabric.product.id === selectedFabricId: false;
			}
			let isSizeOptionIdMatched = false;
			if(!item.selectedSizeOption && !selectedSizeOptionId) {
				isSizeOptionIdMatched = true;
			}
			else {
				isSizeOptionIdMatched = item.selectedSizeOption?.id === selectedSizeOptionId;
			}
			let isFinishIdMatched = item.selectedFinishList?.map((item) => item.id).join(',') === selectedFinishId;
			let isOrderTypeMatched = item.orderType === orderType;
			let isCustomSizeMatched = this._compareCustomSizeObject(item.customSize, customSize);
			// console.log(isFinishIdMatched, isOrderTypeMatched, isFabricIdMatched, isProductIdMatched, isProductGroupMatched, isSizeOptionIdMatched, isCustomSizeMatched);
			return isProductGroupMatched && isProductIdMatched && isFabricIdMatched && isSizeOptionIdMatched && isFinishIdMatched && isOrderTypeMatched && isCustomSizeMatched;
		});

		if (existingFinishedProduct) {
			data.quantity = existingFinishedProduct.quantity + quantity;
			data.id = existingFinishedProduct.id;
			this._updateCartData(data);
		}
		 else {
			this._addCartData(data);
		}
	}



}
